export const Divisions = () => {
    return <>Divisions</>;
}